import { Button, Stack, Table, TableCell, TableRow, Typography } from '@mui/material';

import { enqueueSnackbar } from 'notistack';
import useUnitProvider from '/@/core/context/unit';
import { _ } from '/@/locale';
import { useCreateYieldEstimationMutation } from '/@/store/crop-monitoring/apiProviders';
import type { YieldEstimationAPI } from '../..';

const YieldEstimationResult = ({
    yieldEstimation,
    goBack,
    cropMonitoringId,
    setYieldEstimationDrawerIsOpen,
}: {
    goBack: () => void;
    yieldEstimation: YieldEstimationAPI;
    cropMonitoringId: number;
    setYieldEstimationDrawerIsOpen: (bool: boolean) => void;
}) => {
    const units = useUnitProvider();
    const createYieldEstimationMutation = useCreateYieldEstimationMutation({ cropMonitoringId });

    return (
        <>
            <Stack p={3} borderBottom={(t) => `1px solid ${t.palette.divider}`} spacing={4} overflow={'scroll'}>
                <Stack spacing={1}>
                    <Typography color={'primary'} variant='subtitle1' fontWeight={'bold'}>
                        {_('Rendimiento estimado')}
                    </Typography>
                    <Typography color={'primary'} variant='h6'>
                        {units.toWeightPerArea(Number(yieldEstimation.result) || 0, 2).toString()}
                    </Typography>
                </Stack>

                <Stack spacing={3}>
                    <Typography color={'primary'} variant='subtitle2'>
                        {_('Rendimiento estimado')}
                    </Typography>
                    <Table
                        sx={{
                            fontSize: (t) => t.typography.body2.fontSize,
                            fontFamily: (t) => t.typography.body2.fontFamily,
                            color: (t) => t.palette.primary.main,
                            border: (t) => `1px solid ${t.palette.divider}`,

                            '& .MuiTableCell-root': {
                                fontFamily: (t) => t.typography.body2.fontFamily,
                            },
                        }}
                    >
                        <TableRow sx={{ '& .MuiTableCell-root': { fontWeight: 'bold' } }}>
                            <TableCell>{_('Muestra')}</TableCell>
                            <TableCell>{_('Nombre')}</TableCell>
                            <TableCell>{_('Rendimiento estimado')}</TableCell>
                        </TableRow>
                        {yieldEstimation.yieldSamples.map((el, index) => (
                            <TableRow key={el.id}>
                                <TableCell>{_('Muestra') + ' ' + (index + 1)}</TableCell>
                                <TableCell>{el.name}</TableCell>
                                <TableCell>{units.toWeightPerArea(Number(el.result), 2).toString()}</TableCell>
                            </TableRow>
                        ))}
                    </Table>
                </Stack>
            </Stack>
            <Stack direction={'row'} justifyContent={'flex-end'} spacing={2} p={2}>
                <Button
                    variant='text'
                    color='primary'
                    onClick={() => goBack()}
                    disabled={createYieldEstimationMutation.isMutating}
                >
                    {_('Editar')}
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={async () => {
                        try {
                            await createYieldEstimationMutation.trigger({ ...yieldEstimation, status: 'saved' });
                            enqueueSnackbar(_('Estimación guardada correctamente'), { variant: 'success' });
                            setYieldEstimationDrawerIsOpen(false);
                        } catch (error) {
                            enqueueSnackbar(
                                _('Hubo un problema al guardar la estimación. Por favor, intentá nuevamente.'),
                                { variant: 'error' }
                            );
                        }
                    }}
                    disabled={createYieldEstimationMutation.isMutating}
                >
                    {_('Guardar')}
                </Button>
            </Stack>
        </>
    );
};

export default YieldEstimationResult;
